'use strict';

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _module2 = require('../../module');

var _module3 = _interopRequireDefault(_module2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

// Weeks are represented as moments pointing to the beginning of the week.

function currentWeek() {
    return moment().startOf('isoWeek');
}

function _nextWeek(moment) {
    return moment.clone().add(1, 'weeks');
}

function _prevWeek(moment) {
    return moment.clone().subtract(1, 'weeks');
}

// Try to get a schedule for the given week.
// Return a new state for the component and a list of days.
// The state will reflect whether the request succeeded or failed.
// If the request is canceled, return null instead.
function getSchedule(scheduleService, selectedMoment, intClasses) {
    var year = selectedMoment.isoWeekYear();
    var week = selectedMoment.isoWeek();
    var request = scheduleService.getWeekSchedule(year, week, intClasses);
    return request.then(function (result) {
        if (result) {
            return {
                state: 'ready',
                days: result.items
            };
        } else {
            // It was canceled
            return null;
        }
    }, function (error) {
        console.error('[WinresSchedule] Failed to get schedule:', error);
        return {
            state: 'error',
            days: []
        };
    });
}

var winresScheduleController = function () {
    function winresScheduleController(scheduleService, urlService, $uibModal, $element, $document, $scope) {
        _classCallCheck(this, winresScheduleController);

        this.scheduleService = scheduleService;
        this.urlService = urlService;
        this.$uibModal = $uibModal;
        this.$element = $element;
        this.$document = $document;
        this.$scope = $scope;

        // Possible states:
        // initial - Starting state
        // loading - Loading new data
        // ready - Data loaded, ready to display
        // error - Something went wrong
        this.state = 'initial';

        // Selected moment in time
        this.selectedMoment = currentWeek();

        // Pending request for data, so it can be canceled
        this.pending = null;

        // Data to display
        this.days = [];

        // Internet classifications in url (dc[n]).
        this.internetClassificationsInUrl = [];
    }

    _createClass(winresScheduleController, [{
        key: '$onInit',
        value: function $onInit() {
            this.load();

            this.watchInternetClassificationsInUrl();
        }
    }, {
        key: 'watchInternetClassificationsInUrl',
        value: function watchInternetClassificationsInUrl() {
            var _this = this;

            // Read url query string.
            if (!this.urlService.isKohdeSivu()) {
                // Must not be kohdesivu.
                // Clear internet classifications in url.
                this.internetClassificationsInUrl = [];

                // Watch url params.
                this.$scope.$watch(function () {
                    return _this.urlService.routeParams;
                }, function (params) {
                    if (params !== undefined) {
                        _this.readUrlParams(params);

                        // Reload.
                        _this.load();
                    }
                }, true);
            }
        }
    }, {
        key: 'readUrlParams',
        value: function readUrlParams(params) {
            this.internetClassificationsInUrl = this.getInternetClassifcationsInUrl(params);
        }

        // Get dc[n] from url.

    }, {
        key: 'getInternetClassifcationsInUrl',
        value: function getInternetClassifcationsInUrl(params) {
            var classifications = [];

            for (var i = 1; i <= 5; i++) {
                // dc[n] in url.
                classifications.push(params['dc' + i] != null ? params['dc' + i].split(',') : []);
            }

            return classifications;
        }
    }, {
        key: 'load',
        value: function load() {
            var _this2 = this;

            this.state = 'loading';

            // Param test.
            this.weekCalendar = true;

            this.updateWeekNumberAndWeekYear();

            if (this.pending) {
                this.scheduleService.cancel(this.pending);
                this.pending = null;
            }

            var intClasses = [];

            // Concat internet classifications in bindings and internet classification in url.
            var i = 0;
            for (i = 0; i < 5; i++) {
                intClasses.push(_.compact(_.union(_.concat(this.internetClassificationsInUrl[i], this['internetClassifications' + (i + 1)]))));
            }

            var request = getSchedule(this.scheduleService, this.selectedMoment, intClasses);
            this.pending = request;

            request.then(function (result) {
                if (!result) {
                    // Canceled promise.
                    return;
                } else if (request !== _this2.pending) {
                    console.log('[WinresSchedule] Ignoring completed request because a newer one is pending.');
                    return;
                }
                _this2.state = result.state; // ready or error
                _this2.days = result.days;
            }).catch(function (error) {
                // This error is unlikely since setting the component state is currently
                // trivial. Included anyway just to be sure.
                console.error('[WinresSchedule] Failed to set component state:', error);
                _this2.state = 'error';
                _this2.days = [];
            }).then(function () {
                if (_this2.pending === request) {
                    // The request that just completed was the most recent pending one.
                    _this2.pending = null;
                }
            });
        }
    }, {
        key: 'nextWeek',
        value: function nextWeek() {
            this.selectedMoment = _nextWeek(this.selectedMoment);
            this.load();
        }
    }, {
        key: 'prevWeek',
        value: function prevWeek() {
            this.selectedMoment = _prevWeek(this.selectedMoment);
            this.load();
        }
    }, {
        key: 'updateWeekNumberAndWeekYear',
        value: function updateWeekNumberAndWeekYear() {
            this.weekNumber = this.selectedMoment.format('W');
            this.weekYear = this.selectedMoment.format('GGGG');
        }
    }, {
        key: 'openProductInfoModal',
        value: function openProductInfoModal(_day, _item) {
            console.log("openProductInfoModal() day:", _day, "item: ", _item);
            var modalInstance = this.$uibModal.open({
                component: 'winresProductInfoFlyer',
                size: 'lg',
                // The bootstrap styles are not applying to trying to attach the modal to a webcomponent element instead of the default <body>
                appendTo: this.$document.find('winres-schedule-week').eq(0),
                //appendTo: this.$element,
                backdrop: true,
                backdropClass: 'transparent-modal-backdrop',
                windowClass: 'product-info-modal',
                resolve: {
                    day: function day() {
                        return _day;
                    },
                    item: function item() {
                        return _item;
                    }
                }
            });
        }
    }]);

    return winresScheduleController;
}();

winresScheduleController.$inject = ['scheduleService', 'urlService', '$uibModal', '$element', '$document', '$scope'];

_module3.default.component('winresSchedule', {
    template: require('./winresSchedule.html'),
    controller: winresScheduleController,
    bindings: {
        // Add week select arrows.
        weekCalendar: '@',
        // Internet classifications 1. Separated by ,
        internetClassifications1: '@',
        // Internet classifications 2. Separated by ,
        internetClassifications2: '@',
        // Internet classifications 3. Separated by ,
        internetClassifications3: '@',
        // Internet classifications 4. Separated by ,
        internetClassifications4: '@',
        // Internet classifications 5. Separated by ,
        internetClassifications5: '@'
    }
});


//////////////////
// WEBPACK FOOTER
// ./src/webComponents/components/winresSchedule/winresSchedule.js
// module id = 483
// module chunks = 2